import { addUserError } from "./actions";
import {
  ADD_USER,
  ADD_USER_SUCCESSFUL,
  ADD_USER_ERROR,
  GET_NEW_COGNITO_USER,
  GET_NEW_COGNITO_SUCCESSFUL,
  GET_NEW_COGNITO_USER_FAILED,
  UPDATE_COGNITO_USER,
  UPDATE_COGNITO_USER_SUCCESSFUL,
  UPDATE_COGNITO_USER_FAILED,
  DELETE_COGNITO_USER,
  DELETE_COGNITO_USER_SUCCESSFUL,
  DELETE_COGNITO_USER_FAILED,
} from "./actionTypes";

const initialState = {
  addUserError: null,
  isAddingUser: false,
  updateUserError: null,
  isUpdatingUser: false,
  deleteUserError: null,
  isUserDeleting: false,
  getUsersError: null,
  isGettingUsers: false,
  message: null,
  isLoaded: false,
  isLoading: false,
};

const cognitoUser = (state = initialState, action) => {
  console.log("Action Type :: ", action.type);
  switch (action.type) {
    case ADD_USER:
      state = {
        ...state,
        // loading: true,
        isAddingUser: true,
        addUserError: null,
        user: null,
      };
      break;
    case ADD_USER_SUCCESSFUL:
      state = {
        ...state,
        // loading: false,
        user: action.payload.user,
        isAddingUser: false,
        addUserError: null,
      };
      break;
    case ADD_USER_ERROR:
      // console.log("Reducer :: ", action.payload.error.response.data)
      state = {
        ...state,
        // loading: false,
        isAddingUser: false,
        addUserError: action.payload.error.response.data,
      };
      console.log("Reducer :: ", state.addUserError);
      break;

    case GET_NEW_COGNITO_USER:
      state = {
        ...state,
        isGettingUsers: true,
        getUsersError: null,
        isLoading: true,
        //Added the following for spinner
        loading: true,
      };
      break;

    case GET_NEW_COGNITO_SUCCESSFUL:
      console.log("payload = ", action.payload);
      console.log("users = ", Object.values(action.payload.user));
      const users = action.payload.user;
      // const usersWithIds = users.map((user, index) => {
      //   console.log("payload = ", user);
      //   // Use the index as the unique id for each user object
      //   return { ...user, index };
      // });
      state = {
        ...state,
        isLoading: false,
        isGettingUsers: false,
        getUsersError: null,
        //Added for spinner
        loading: false,
        isLoaded: true,
        users: action.payload.user.users,
      };
      break;

    case GET_NEW_COGNITO_USER_FAILED:
      state = {
        ...state,
        loading: false,
        isGettingUsers: false,
        getUsersError: action.payload.response.status,
        message: action.payload.response.data,
        // userError: action.payload.response.status,
      };
      break;

    //Added for Update/delete cognito user
    case UPDATE_COGNITO_USER:
      console.log(
        "reducer -> UPDATE_COGNITO_USER called with user: ",
        action.payload.user
      );
      state = {
        ...state,
        // loading: true,
        isUpdatingUser: true,
        updateUserError: null,
        user: null,
      };
      console.log("reducer -> UPDATE_COGNITO_USER state is ", state);
      break;
    case UPDATE_COGNITO_USER_SUCCESSFUL:
      console.log(
        "reducer -> UPDATE_COGNITO_USER_SUCCESSFUL called with",
        action.payload.user
      );
      state = {
        ...state,
        isUpdatingUser: false,
        updateUserError: null,
        user: action.payload.user,
      };
      break;

    case UPDATE_COGNITO_USER_FAILED:
      state = {
        ...state,
        isUpdatingUser: false,
        updateUserError: action.payload.error,
      };
      break;
    case DELETE_COGNITO_USER:
      state = {
        ...state,
        // loading: true,
        isDeletingUser: true,
        deleteUserError: null,
        username: null,
      };
      break;

    case DELETE_COGNITO_USER_SUCCESSFUL:
      state = {
        ...state,
        isUserDeleting: false,
        deleteUserError: null,
        username: action.payload.username,
      };
      break;
    case DELETE_COGNITO_USER_FAILED:
      state = {
        ...state,
        isUserDeleting: false,
        deleteUserError: action.payload.error,
      };
      break;

    default:
      return state;
  }
  return state;
};

export default cognitoUser;
